export default __webpack_public_path__ + "assets/8d8e3897f2fac0027e0cfccfbaf727df.jpeg";